import { STAGE } from 'src/constants/enums';
import { getCurrentStage } from 'src/utils/StageConfigUtils';
import * as z from 'zod/v3';

export const RecepientType = z.enum(['to', 'cc'] as const);

export const MCBulkEmailRowSchema = z
  .object({
    CaseId: z.string(),
    'Template Unique Name': z.string(),
    'Contact Email': z.literal(RecepientType.Values.to).optional(),
    'Contact AmazonEmail': z.literal(RecepientType.Values.to).optional(),
    'HRBP Email': RecepientType.optional(),
    'Hiring Manager Email': RecepientType.optional(),
    'Recruiter Email': RecepientType.optional(),
    'Skip Level Manager Email': RecepientType.optional(),
    EmailOverride:
      getCurrentStage() !== STAGE.PROD
        ? z.string().email()
        : z.string().email().optional()
  })
  .refine(
    (data) => {
      // Check if at least one of Contact Email or Contact AmazonEmail is present and has value 'to'
      return (
        data['Contact Email'] === RecepientType.Values.to ||
        data['Contact AmazonEmail'] === RecepientType.Values.to
      );
    },
    {
      message:
        "At least one of 'Contact Email' or 'Contact AmazonEmail' must be present with value 'to'"
    }
  );

export const MCBulkEmailSchema = z
  .array(MCBulkEmailRowSchema)
  .refine(
    (data) => {
      const caseIds = data.map((row) => row.CaseId);
      const uniqueCaseIds = new Set(caseIds);
      return caseIds.length === uniqueCaseIds.size;
    },
    {
      message: 'CaseId must be unique for each record'
    }
  )
  .refine((data) => data.length !== 0, {
    message: 'Non zero number of rows required'
  });
